import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export type TicketPriority = 'low' | 'medium' | 'high' | 'urgent';

const priorityConfig: Record<TicketPriority, { label: string; className: string }> = {
  low: {
    label: 'Low',
    className: 'bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-100',
  },
  medium: {
    label: 'Medium',
    className: 'bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-100',
  },
  high: {
    label: 'High',
    className: 'bg-orange-100 text-orange-800 border-orange-200 hover:bg-orange-100',
  },
  urgent: {
    label: 'Urgent',
    className: 'bg-red-100 text-red-800 border-red-200 hover:bg-red-100',
  },
};

interface TicketPriorityBadgeProps {
  /** `null`/undefined renders a muted "Unset" badge. */
  priority: TicketPriority | null | undefined;
  className?: string;
}

const UNSET_CONFIG = {
  label: 'Unset',
  className: 'bg-muted text-muted-foreground border-transparent hover:bg-muted',
};

export function TicketPriorityBadge({ priority, className }: TicketPriorityBadgeProps) {
  const config = priority ? priorityConfig[priority] : UNSET_CONFIG;

  return (
    <Badge variant="outline" className={cn(config.className, className)}>
      {config.label}
    </Badge>
  );
}
